export default (theme) => ({
  input: {
    width: '100%',
  },
  autocompleteRoot: {
    width: '100%',
  },
  tag: {
    backgroundColor: theme.color.white,
    border: `1px solid ${theme.color.grey_d3}`,
    fontSize: 14,
    height: 20,
    lineHeight: '20px',
  },
  deleteIcon: {
    width: 14,
    height: 14,
  },
});
